export var isLoading = function (state) {
    return state.tag !== "error" && state.loading;
};
export var getHasMore = function (state) {
    switch (state.tag) {
        case "with-data":
            return state.hasMore;
        case "empty":
            return true;
        default:
            return false;
    }
};
export var isAllSelected = function (state, selecteds, idExtractor) {
    if (state.tag === "with-data") {
        for (var index = 0; index < state.list.length; index++) {
            var element = state.list[index];
            if ((selecteds === null || selecteds === void 0 ? void 0 : selecteds.includes(idExtractor(element))) === false) {
                return false;
            }
        }
    }
    return true;
};
export var getListOrDefault = function (state) {
    return state.tag === "with-data" ? state.list : [];
};
//# sourceMappingURL=ListLib.js.map